module.exports = __webpack_public_path__ + "static/media/Facebook.e9dbd6a3.svg";